module.exports = __webpack_public_path__ + "img/bottomList1.d8fb1384.svg";